import Axios from "axios";
import {
    SET_UNIT_LIST,
    UNSET_UNIT_LIST,
  } from "@/store/mutation-types";
import { saveUpdateUnit, getUnitList, generateUnitCode } from "@/store/api";
// initial state
const state = {
  getUnitList: [],
};

const getters = {
  getUnitList(state) {
    return state.getUnitList;
  },
};

const mutations = {
  [SET_UNIT_LIST](state, data) {
    state.getUnitList = data;
  },
  [UNSET_UNIT_LIST](state) {
    state.getUnitList = [];
  }
};

const actions = {

  saveUpdateUnit({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateUnit, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getUnitList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getUnitList, data)
        .then(function (response) {
          commit('SET_UNIT_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_UNIT_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  }, 
};

export default {
  state,
  getters,
  actions,
  mutations,
};
